//TODO-SIMEN REPLACE ALL THESE WITH LOCALIZED SOUNDS

import sfTrial1 from '../assets/nn//sf-trial-1.mp3';
import sfTrial1Wrong from '../assets/nn//sf-trial-1-wrong.mp3';

import sfTrialCorrect from '../assets/nn//sf-trial-correct.mp3';

import sfTrial2 from '../assets/nn//sf-trial-2.mp3';
import sfTrial2Wrong from '../assets/nn//sf-trial-2-wrong.mp3';

import sfTrial3 from '../assets/nn//sf-trial-3.mp3';
import sfTrial3Wrong from '../assets/nn//sf-trial-3-wrong.mp3';
import sfTrial3Correct from '../assets/nn//sf-trial-3-correct.mp3';
import sfTrial3HalfCorrect from '../assets/nn//sf-trial-3-incorrect-order.mp3';

import trial1_1 from '../assets/TrialImages/trial1_1.png';
import trial1_2 from '../assets/TrialImages/trial1_2.png';
import trial1_3 from '../assets/TrialImages/trial1_3.png';
import trial1_4 from '../assets/TrialImages/trial1_4.png';

import trial2_1 from '../assets/TrialImages/trial2_1.png';
import trial2_2 from '../assets/TrialImages/trial2_2.png';
import trial2_3 from '../assets/TrialImages/trial2_3.png';
import trial2_4 from '../assets/TrialImages/trial2_4.png';

import trial3_1 from '../assets/TrialImages/trial3_1.png';
import trial3_2 from '../assets/TrialImages/trial3_2.png';
import trial3_3 from '../assets/TrialImages/trial3_3.png';
import trial3_4 from '../assets/TrialImages/trial3_4.png';
import trial3_5 from '../assets/TrialImages/trial3_5.png';
import trial3_6 from '../assets/TrialImages/trial3_6.png';

import starterTesten from 'assets/sounds/nn/Intro-after-sprakforstaelse.mp3';

export const starterTestenSound = starterTesten;

export const bytteLydenExample = {};

export const tutorialAssignment = {
	id: 1,
	choices: [
		{
			word: 'Lys',
		},
		{
			word: 'Lese',
		},
		{
			word: 'Katt',
		},
		{
			isCorrect: true,
			word: 'Kam',
		},
	],
};
export const assignment1 = [
	{
		id: 1,

		mainSound: sfTrial1,
		wrongAnswerText: 'Dette blei dessverre ikkje riktig.',
		wrongAnswerSound: sfTrial1Wrong,
		rightAnswerText: 'Du fann heilt riktig bilde, så bra!',
		rightAnswerSound: sfTrialCorrect,
		text: '1. Finn bildet som viser at dama ikke skriver på datamaskinen, men leser en bok ',
		choices: [
			{
				choiceGroup: [
					{
						groupId: 1,
						currentClass: 'imgItem',
						remark: true,
						word: 'a',

						img: trial1_1,
					},
					{
						groupId: 2,
						currentClass: 'imgItem',
						remark: false,
						word: 'b',

						img: trial1_2,
					},
				],
			},
			{
				choiceGroup: [
					{
						groupId: 3,
						currentClass: 'imgItem',
						remark: false,
						word: 'c',

						img: trial1_3,
					},
					{
						groupId: 4,
						currentClass: 'imgItem',
						remark: false,
						word: 'd',

						img: trial1_4,
					},
				],
			},
		],
		order: ['b'],
	},
];

export const assignment2 = [
	{
		id: 2,
		text: '2. Velg gutten som smiler fordi han har fått en presang',
		mainSound: sfTrial2,
		wrongAnswerText: 'Dette blei dessverre ikkje riktig.',
		wrongAnswerSound: sfTrial2Wrong,
		rightAnswerText: 'Du fann heilt riktig bilde, så bra!',
		rightAnswerSound: sfTrialCorrect,
		choices: [
			{
				choiceGroup: [
					{
						groupId: 1,
						currentClass: 'imgItem',
						remark: true,
						word: 'a',

						img: trial2_1,
					},
					{
						groupId: 2,
						currentClass: 'imgItem',
						remark: false,
						word: 'b',

						img: trial2_2,
					},
				],
			},
			{
				choiceGroup: [
					{
						groupId: 3,
						currentClass: 'imgItem',
						remark: false,
						word: 'c',

						img: trial2_3,
					},
					{
						groupId: 4,
						currentClass: 'imgItem',
						remark: false,
						word: 'd',

						img: trial2_4,
					},
				],
			},
		],
		order: ['a'],
	},
];

export const assignment3 = [
	{
		id: 3,

		mainSound: sfTrial3,
		text: '3. Nå skal vi øve på å trykke på objekter i riktig rekkefølge. Du skal trykke på fruktene i den rekkefølgen jeg sier dem. "Trykk nå på fruktene i den rekkefølgen jeg sier: eple, banan, ananas. ',
		wrongAnswerText: 'Dette blei dessverre ikkje riktig.',
		wrongAnswerSound: sfTrial3Wrong,
		rightAnswerText:
			'Så flott! Du valde riktige bilda og riktig rekkefølge',
		partialAnswerText: 'Du valde riktige bilda, men i feil rekkefølge',
		partialAnswerSound: sfTrial3HalfCorrect,
		rightAnswerSound: sfTrial3Correct,
		choices: [
			{
				choiceGroup: [
					{
						groupId: 1,
						currentClass: 'imgItem',
						remark: true,
						word: 'a',

						img: trial3_1,
					},
					{
						groupId: 2,
						currentClass: 'imgItem',
						remark: false,
						word: 'b',

						img: trial3_2,
					},
					{
						groupId: 3,
						currentClass: 'imgItem',
						remark: false,
						word: 'c',

						img: trial3_3,
					},
				],
			},
			{
				choiceGroup: [
					{
						groupId: 4,
						currentClass: 'imgItem',
						remark: false,
						word: 'd',

						img: trial3_4,
					},
					{
						groupId: 5,
						currentClass: 'imgItem',
						remark: false,
						word: 'e',

						img: trial3_5,
					},
					{
						groupId: 6,
						currentClass: 'imgItem',
						remark: false,
						word: 'f',

						img: trial3_6,
					},
				],
			},
		],
		order: ['c', 'a', 'd'],
	},
];
export const assignment4 = [
	{
		id: 4,

		choices: [
			{
				remark: true,
				word: 'modil',
				comment: '',

				img: '',
			},
			{
				remark: true,
				word: 'vuks',
				comment: '',

				img: '',
			},
			{
				remark: true,
				word: 'fålk',
				comment: '',

				img: '',
			},
			{
				remark: true,
				word: 'flynt',
				comment: '',

				img: '',
			},
		],
	},
];
export const assignment5 = [
	{
		id: 5,

		choices: [
			{
				word: 'modil',
				comment: '',

				img: '',
			},
			{
				word: 'vuks',
				comment: '',

				img: '',
			},
			{
				word: 'fålk',
				comment: '',

				img: '',
			},
			{
				word: 'flynt',
				comment: '',

				img: '',
			},
		],
	},
];

export const assignments = [
	{
		id: 2,

		choices: [
			{
				word: 'modil',
				comment: '',

				img: '',
			},
			{
				word: 'vuks',
				comment: '',

				img: '',
			},
			{
				word: 'fålk',
				comment: '',

				img: '',
			},
			{
				word: 'flynt',
				comment: '',

				img: '',
			},
		],
	},
	{
		id: 3,

		choices: [
			{
				word: 'vorr',
				comment:
					'Vorr er riktig, fordi det er et spørreord som vi bruker når vi for eksempel lurer på hvor noen befinner seg. Vi skriver ikke ordet slik, men uttaler det slik.',

				img: '',
			},
			{
				word: 'blastell',
				comment:
					'Blastell er feil. Dette ordet finnes ikke på norsk, og det betyr ingen ting.',

				img: '',
			},
			{
				word: 'peano',
				comment:
					'Peano er feil, fordi vi sier ikke peano – men piano. Ordet peano finnes ikke på norsk, og det betyr ingen ting.',

				img: '',
			},
			{
				word: 'knain',
				comment:
					'Knain er feil. Dette ordet finnes ikke på norsk, og det betyr ingen ting.',

				img: '',
			},
		],
	},
	{
		id: 4,

		choices: [
			{
				word: 'vorr',
				comment:
					'Vorr er riktig, fordi det er et spørreord som vi bruker når vi for eksempel lurer på hvor noen befinner seg. Vi skriver ikke ordet slik, men uttaler det slik.',

				img: '',
			},
			{
				word: 'blastell',
				comment:
					'Blastell er feil. Dette ordet finnes ikke på norsk, og det betyr ingen ting.',

				img: '',
			},
			{
				word: 'peano',
				comment:
					'Peano er feil, fordi vi sier ikke peano – men piano. Ordet peano finnes ikke på norsk, og det betyr ingen ting.',

				img: '',
			},

			{
				word: 'brillter',
				comment:
					'Brillter er feil, fordi vi sier ikke brillter – men briller. Ordet brillter finnes ikke på norsk, og det betyr ingen ting.',

				img: '',
			},
		],
	},
	{
		id: 5,

		choices: [
			{
				word: 'vorr',
				comment:
					'Vorr er riktig, fordi det er et spørreord som vi bruker når vi for eksempel lurer på hvor noen befinner seg. Vi skriver ikke ordet slik, men uttaler det slik.',

				img: '',
			},
			{
				word: 'blastell',
				comment:
					'Blastell er feil. Dette ordet finnes ikke på norsk, og det betyr ingen ting.',

				img: '',
			},

			{
				word: 'knain',
				comment:
					'Knain er feil. Dette ordet finnes ikke på norsk, og det betyr ingen ting.',

				img: '',
			},
			{
				word: 'brillter',
				comment:
					'Brillter er feil, fordi vi sier ikke brillter – men briller. Ordet brillter finnes ikke på norsk, og det betyr ingen ting.',

				img: '',
			},
		],
	},
	{
		id: 6,

		choices: [
			{
				word: 'vorr',
				comment:
					'Vorr er riktig, fordi det er et spørreord som vi bruker når vi for eksempel lurer på hvor noen befinner seg. Vi skriver ikke ordet slik, men uttaler det slik.',

				img: '',
			},
			{
				word: 'blastell',
				comment:
					'Blastell er feil. Dette ordet finnes ikke på norsk, og det betyr ingen ting.',

				img: '',
			},

			{
				word: 'knain',
				comment:
					'Knain er feil. Dette ordet finnes ikke på norsk, og det betyr ingen ting.',

				img: '',
			},
			{
				word: 'brillter',
				comment:
					'Brillter er feil, fordi vi sier ikke brillter – men briller. Ordet brillter finnes ikke på norsk, og det betyr ingen ting.',

				img: '',
			},
		],
	},
];
